import React from 'react'
import { Link } from 'react-router-dom'
import { OnboardingStepHeader } from '../OnboardingStepHeader/OnboardingStepHeader'
import classNames from 'classnames'
import styles from './OnboardingStepFinished.module.scss'
import { OnboardingStepLink } from '../../copies/onboardingCopies'

interface OnboardingStepFinishedStateProps {
  title: string
  bullets: string[]
  links?: OnboardingStepLink[]
  showDecoration?: boolean
}

export const OnboardingStepFinished: React.FC<OnboardingStepFinishedStateProps> = ({ title, bullets, links, showDecoration = true }) => (
  <OnboardingStepHeader icon={<i className='bi bi-check-circle text-success' />} title={title} showDecoration={showDecoration}>
    {bullets.length > 0 ? (
      <ul className={classNames(styles.bullets, 'list-unstyled m-0 d-flex flex-column gap-2 align-self-center')}>
        {bullets.map((bullet, i) => (
          <li key={i} className={classNames(styles.bullet, 'd-flex align-items-center gap-2 fw-bold text-dark')}>
            <i className={classNames(styles.bulletIcon, 'bi bi-check-circle flex-shrink-0')} />
            <span>{bullet}</span>
          </li>
        ))}
      </ul>
    ) : null}
    {links && links.length > 0 ? (
      <div className={classNames(styles.links, 'w-100 d-flex flex-column align-items-center gap-1 pt-3')}>
        {links.map(({ label, to }) => (
          <Link key={to} to={to} className={classNames(styles.link, 'fw-bold text-decoration-none')}>
            {label}
          </Link>
        ))}
      </div>
    ) : null}
  </OnboardingStepHeader>
)
